module.exports = __webpack_public_path__ + "static/media/unico-ferragens.13a6331c.webp";